import * as React from 'react';
import { EditModeEnum } from '../interfaces/state';

interface EventListButtonProps {
    onClick: () => void;
}

export class EventListButton extends React.Component<EventListButtonProps> {
    constructor(props: EventListButtonProps) {
        super(props);
    }

    render() {
        return (
            <button id="EventList" className="btn btn-primary" type="button" onClick={() => this.props.onClick()}>
                Events List&nbsp;
            </button>
        );
    }
}